import { render, staticRenderFns } from "./LayoutAnimationSettingsModal.vue?vue&type=template&id=1b0c1dcc&scoped=true"
import script from "./LayoutAnimationSettingsModal.vue?vue&type=script&lang=js"
export * from "./LayoutAnimationSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./LayoutAnimationSettingsModal.vue?vue&type=style&index=0&id=1b0c1dcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c1dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0c1dcc')) {
      api.createRecord('1b0c1dcc', component.options)
    } else {
      api.reload('1b0c1dcc', component.options)
    }
    module.hot.accept("./LayoutAnimationSettingsModal.vue?vue&type=template&id=1b0c1dcc&scoped=true", function () {
      api.rerender('1b0c1dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layout-animation/LayoutAnimationSettingsModal.vue"
export default component.exports